import { clsx } from 'clsx'
import styles from './LiveLabel.module.scss'

type LiveLabelProps = {
  url?: string
  position?: 'top-left' | 'bottom-right'
  className?: string
}

const LiveLabel = ({ url, position = 'top-left', className }: LiveLabelProps) => {
  if (!url || (!url.includes('livestream') && !url.includes('liveticker'))) {
    return null
  }

  return (
    <div className={clsx(styles.box, styles[position], className)} data-cy="live-label">
      <span className={styles.indicator} data-cy="live-label_indicator" />
      <span className={styles.label} data-cy="live-label_label">
        Live
      </span>
    </div>
  )
}

export default LiveLabel
